import {initWebComponent} from "@/helpers/web-component-helper";
import {LayerMenuGroupComponent} from "@/components/layer/menu/overview/layer-menu-group-component";
import {LayerMenuGroupItemComponent} from "@/components/layer/menu/overview/layer-menu-group-item-component";
import {LayerMenuSwitcherComponent} from "@/components/layer/menu/switcher/layer-menu-switcher-component";
import {LayerMenuOverviewComponent} from "@/components/layer/menu/overview/layer-menu-overview-component";
import {LayerMenuSearchComponent} from "@/components/layer/menu/layer-menu-search-component";
import {LayerMenuActiveComponent} from "@/components/layer/menu/active/layer-menu-active-component";
import {
    LayerMenuOverviewCollapseComponent
} from "@/components/layer/menu/overview/layer-menu-overview-collapse-component";
import {LayerMenuButtonFilterComponent} from "@/components/layer/menu/button/layer-menu-button-filter-component";
import {LayerMenuButtonMutationComponent} from "@/components/layer/menu/button/layer-menu-button-mutation-component";
import {LayerMenuButtonInfoComponent} from "@/components/layer/menu/button/layer-menu-button-info-component";
import {LayerMenuGroupMergedComponent} from "@/components/layer/menu/overview/layer-menu-group-merged-component";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {getDefaultSession} from "@/helpers/user-session-helper";
import {LayerInfoLegendSearchComponent} from "@/components/layer/info/legend/layer-info-legend-search-component";
import {getToken} from "@/helpers/auth/auth-helper";
import {isMobile} from "@/helpers/mobile-helper";
import {LayerMenuButtonZoomScaleComponent} from "@/components/layer/menu/button/layer-menu-button-zoom-scale-component";
import {blockUi} from "@/modules/elements-blockui";
import {LayerMenuOverviewResetComponent} from "@/components/layer/menu/overview/layer-menu-overview-reset-component.js";
import {LayerMenuCompareComponent} from "@/components/layer/menu/compare/layer-menu-compare-component.js";
import {LayerMenuButtonCheck} from "@/components/layer/menu/button/layer-menu-button-check.js";
import {initPopper} from "@/modules/popper.js";
import {
    BookmarkUserSessionStartButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-start-button-component.js";
import {
    BookmarkUserSessionStopButtonComponent
} from "@/components/bookmark/usersession/bookmark-user-session-stop-button-component.js";

const template = document.createElement('template');

export class LayerMenuComponent extends HTMLElement{
    constructor(){
        super();

        let minWidth = window.settings.MenuBreedte
        if(!minWidth) {
            minWidth = '300px'
        }

        if(isMobile()) {
            minWidth = '100vw'
        }

        const defaultSession = getDefaultSession()

        let displayNoneCatalogus = ''
        let displayNoneMyLayers = 'd-none'
        let isChecked = ''
        if(getDefaultSession()) {
            displayNoneCatalogus = 'd-none'
            displayNoneMyLayers = ''
            isChecked = "1"
        }


        let innerHTML =  `
<div class="layer-menu row position-absolute ml-2" data-testid="catalog" style="width: ` + minWidth + `;z-index: 1;top:55px;">
    <div class="col-md">
        <h3 class="mt-2 mb-1">

             <layer-menu-switcher-button-active data-checked="${isChecked}"></layer-menu-switcher-button-active>
            
        </h3>
        <hr class="mb-2 mt-2">`

    innerHTML +=
        `
        <layer-menu-switcher class="${displayNoneMyLayers}"></layer-menu-switcher>
        <div class="pb-1 layer-tree">
            <div class="zoeklagen d-none"><layer-menu-search class="${displayNoneCatalogus}"></layer-menu-search></div>
            <div class="layer-tree-container">`


        let sessionName = ''
        let sessionID = ''
        let sessionVisible = 'd-none'
        if(defaultSession) {
            sessionName = defaultSession.Name
            sessionVisible = ''
            sessionID = defaultSession.ID
        }

        innerHTML += `
        <div class="ml-2 mb-2 ` + sessionVisible + `" id="divActiveSession">
            <span class="fa fa-bookmark"></span> 
            <span id="spnActiveSession">` + sessionName + `</span> </span>   
            <div id="divActiveSessionButton" class="float-right">
                <bookmark-user-session-update-button data-id="${sessionID}"></bookmark-user-session-update-button>
            </div>
                <bookmark-user-session-stop-button></bookmark-user-session-stop-button>
         </div>`

          innerHTML +=  `  
                <div id="fillCatalog" class="d-none">
                    <div class="card accordion-group bg-lighter ">
                        <div class="card-header pl-2 pr-2"><a data-bs-toggle="collapse" data-bs-target="#collapse0-107" class="layerMenuGroupToggleHeader accordion-header justify-content-between text-body" aria-expanded="true" href="#">
                        <span class="fa fa-folder"></span>
                        <span class="spnName" title="Samengevoegd">Groep 1</span>
                            <span class="float-right">
                                 <span class="collapse-icon"></span>     
                            </span>
                        </a>
                    </div>
                </div>
                    <div class="card accordion-group bg-lighter ">
                        <div class="card-header pl-2 pr-2"><a data-bs-toggle="collapse" data-bs-target="#collapse0-107" class="layerMenuGroupToggleHeader accordion-header justify-content-between text-body" aria-expanded="true" href="#">
                        <span class="fa fa-folder"></span>
                        <span class="spnName" title="Samengevoegd">Groep 2</span>
                            <span class="float-right">
                                 <span class="collapse-icon"></span>     
                            </span>
                        </a>
                    </div>
                </div>
                    <div class="card accordion-group bg-lighter ">
                        <div class="card-header pl-2 pr-2"><a data-bs-toggle="collapse" data-bs-target="#collapse0-107" class="layerMenuGroupToggleHeader accordion-header justify-content-between text-body" aria-expanded="true" href="#">
                        <span class="fa fa-folder"></span>
                        <span class="spnName" title="Samengevoegd">Groep 3</span>
                            <span class="float-right">
                                 <span class="collapse-icon"></span>     
                            </span>
                        </a>
                    </div>
                </div>
                
<!--                    Bezig met vullen van catalogus...-->
<!--                    <div class="sk-wave sk-secondary d-inline-flex">-->
<!--                        <div class="sk-wave-rect"></div>-->
<!--                        <div class="sk-wave-rect"></div>-->
<!--                        <div class="sk-wave-rect"></div>-->
<!--                        <div class="sk-wave-rect"></div>-->
<!--                        <div class="sk-wave-rect"></div>-->
<!--                    </div> -->
                </div>
                <layer-menu-overview class="${displayNoneCatalogus}"></layer-menu-overview> 
                <layer-menu-active class="${displayNoneMyLayers}"></layer-menu-active> 
                <layer-menu-compate class="${displayNoneMyLayers}"></layer-menu-compate> 
            </div>
        </div>
    </div>
</div>`

        template.innerHTML = innerHTML
        initWebComponent(this, template)

        setTimeout(() => {
            showElementsBySelector('#fillCatalog')
            blockUi('#fillCatalog', 0.6, '<p>Bezig met ophalen van de catalogus...</p>')
        }, 1500)

        initPopper()
    }
}

window.customElements.define("layer-menu-group", LayerMenuGroupComponent);
window.customElements.define("layer-menu-overview-collapse", LayerMenuOverviewCollapseComponent);
window.customElements.define("layer-menu-overview-reset", LayerMenuOverviewResetComponent);
window.customElements.define("layer-menu-group-item", LayerMenuGroupItemComponent);
window.customElements.define("layer-menu-group-merged", LayerMenuGroupMergedComponent);
window.customElements.define("layer-menu-switcher", LayerMenuSwitcherComponent);
window.customElements.define("layer-menu-overview", LayerMenuOverviewComponent);
window.customElements.define("layer-menu-search", LayerMenuSearchComponent);
window.customElements.define("layer-menu-active", LayerMenuActiveComponent);
window.customElements.define("layer-menu-button-filter", LayerMenuButtonFilterComponent);
window.customElements.define("layer-menu-button-info", LayerMenuButtonInfoComponent);
window.customElements.define("layer-menu-button-mutation", LayerMenuButtonMutationComponent);
window.customElements.define("layer-menu-button-zoom-scale", LayerMenuButtonZoomScaleComponent);
window.customElements.define("layer-info-legend-search", LayerInfoLegendSearchComponent);
window.customElements.define("layer-menu-button-check", LayerMenuButtonCheck);
window.customElements.define("bookmark-user-session-stop-button", BookmarkUserSessionStopButtonComponent);
